import { render, staticRenderFns } from "./rateTemplate.vue?vue&type=template&id=2ae05f10&scoped=true&"
import script from "./rateTemplate.vue?vue&type=script&lang=js&"
export * from "./rateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./rateTemplate.vue?vue&type=style&index=0&id=2ae05f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae05f10",
  null
  
)

export default component.exports